module.exports = __webpack_public_path__ + "static/media/15.8d2a3474.jpg";